import type { VFC } from 'react'
import {
  Form
} from '@panwds/react-form'
import {
  useToast
} from '@panwds/react-ui'
import TrustedIpTable from './table/TrustedIpTable'
import { useCallback } from 'react'
import { useModal } from '../../common/components/modal/Modal'
import IpSaveModal from './modal/IpSaveModal'
import StringTemplate from '../../common/utils/StringTemplate'
import { LABEL_TRUSTED_IPS_ADDED } from '../constants/LabelConstants'

const TrustedIpForm: VFC<any> = ({ getAllowedIps, loading }) => {

  const saveModal = useModal(IpSaveModal)
  const { toast } = useToast()

  const callback = useCallback((length) => {
    const message = StringTemplate(LABEL_TRUSTED_IPS_ADDED, [length]) as string
    toast(message, { appearance: 'success' })
  }, [toast])

  const onSubmit = useCallback((formBody) => {
    saveModal.openModal({ formBody, callback } as any)
  }, [saveModal, callback])

  return (
    <Form
      mode={'onChange'}
      onSubmit={onSubmit}
    >
      <TrustedIpTable {...{ getAllowedIps, loading }} />
    </Form>
  )
}

export default TrustedIpForm
